<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
      <Breadcrumb :options="crumbOptions"></Breadcrumb>
      <div class="title">{{ dataList.title }}</div>
      <div class="content">
        <div v-html="dataList.contentDetail"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import { getResolveCrumb } from '@/utils/crumb.js'
import { serviceList } from '../configs/config'
export default {
  data() {
    return {
      serviceList,
      dataList: {}
    }
  },
  created() {
    this.settingCrumb()
    const { id } = this.$route.query
    this.dataList = serviceList[id - 1]
    // console.log(this.dataList);
  },
  components: {
    Breadcrumb
  },
  methods: {
    settingCrumb() {
      const { path, query: { name } } = this.$route
      const crumbOptions = getResolveCrumb(path, name)
      this.crumbOptions = crumbOptions
    }
  }
}
</script>

<style>
</style>
